module.exports = "<p>\n  print-form-challan works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/candidate/print-form-challan/print-form-challan.component.html
// module id = ./src/app/candidate/print-form-challan/print-form-challan.component.html
// module chunks = main